// ----------------------------------------------------------------------

const account = {
  displayName: 'Maleek Ka Naam',
  email: 'demo@minimals.cc',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;

let mockGamesData = {
  results: [
    {
      market_status: 'closed',
      stop_open_bid: true,
      stop_close_bid: true,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c637fb9543fd0032ad52c6',
      user: '64c540710f7c57368700fe1b',
      game_name: 'RUDRAKSHA MORNING ',
      open_time: '2023-08-09T04:30:00.000Z',
      close_time: '2023-08-09T05:30:00.000Z',
      createdAt: '2023-07-30T10:14:19.121Z',
      updatedAt: '2023-08-09T07:14:40.438Z',
      __v: 0,
    },
    {
      market_status: 'closed',
      stop_open_bid: true,
      stop_close_bid: true,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c638f29543fd0032ad52ff',
      user: '64c540710f7c57368700fe1b',
      game_name: 'MILAN MORNING ',
      open_time: '2023-08-09T04:30:00.000Z',
      close_time: '2023-08-09T05:30:00.000Z',
      createdAt: '2023-07-30T10:18:26.434Z',
      updatedAt: '2023-08-09T07:14:40.438Z',
      __v: 0,
    },
    {
      market_status: 'closed',
      stop_open_bid: true,
      stop_close_bid: true,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c6390f9543fd0032ad530d',
      user: '64c540710f7c57368700fe1b',
      game_name: 'KALYAN MORNING ',
      open_time: '2023-08-09T05:20:00.000Z',
      close_time: '2023-08-09T06:20:00.000Z',
      createdAt: '2023-07-30T10:18:55.130Z',
      updatedAt: '2023-08-09T07:14:40.438Z',
      __v: 0,
    },
    {
      market_status: 'closed',
      stop_open_bid: true,
      stop_close_bid: true,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c639489543fd0032ad5317',
      user: '64c540710f7c57368700fe1b',
      game_name: 'MADHUR MORNING ',
      open_time: '2023-08-09T05:50:00.000Z',
      close_time: '2023-08-08T18:50:00.000Z',
      createdAt: '2023-07-30T10:19:52.979Z',
      updatedAt: '2023-08-09T07:14:40.438Z',
      __v: 0,
    },
    {
      market_status: 'closed',
      stop_open_bid: true,
      stop_close_bid: true,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c6397a9543fd0032ad5335',
      user: '64c540710f7c57368700fe1b',
      game_name: 'SRIDEVI DAY',
      open_time: '2023-08-09T05:55:00.000Z',
      close_time: '2023-08-09T06:55:00.000Z',
      createdAt: '2023-07-30T10:20:42.194Z',
      updatedAt: '2023-08-09T07:14:40.438Z',
      __v: 0,
    },
    {
      market_status: 'closed',
      stop_open_bid: true,
      stop_close_bid: true,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c639ad9543fd0032ad533a',
      user: '64c540710f7c57368700fe1b',
      game_name: 'TIME BAZAR ',
      open_time: '2023-08-09T06:25:00.000Z',
      close_time: '2023-08-09T07:25:00.000Z',
      createdAt: '2023-07-30T10:21:33.881Z',
      updatedAt: '2023-08-09T07:25:00.679Z',
      __v: 0,
    },
    {
      market_status: 'closed',
      stop_open_bid: true,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c639ed9543fd0032ad535b',
      user: '64c540710f7c57368700fe1b',
      game_name: 'MADHUR DAY',
      open_time: '2023-08-09T07:40:00.000Z',
      close_time: '2023-08-09T08:40:00.000Z',
      createdAt: '2023-07-30T10:22:37.222Z',
      updatedAt: '2023-08-09T07:40:00.785Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c63a1a9543fd0032ad535f',
      user: '64c540710f7c57368700fe1b',
      game_name: 'RUDRAKSHA DAY',
      open_time: '2023-08-09T08:30:00.000Z',
      close_time: '2023-08-09T09:30:00.000Z',
      createdAt: '2023-07-30T10:23:22.862Z',
      updatedAt: '2023-08-09T07:14:30.529Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c63a449543fd0032ad5363',
      user: '64c540710f7c57368700fe1b',
      game_name: 'MILAN DAY',
      open_time: '2023-08-09T09:25:00.000Z',
      close_time: '2023-08-09T11:25:00.000Z',
      createdAt: '2023-07-30T10:24:04.467Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c63a609543fd0032ad5367',
      user: '64c540710f7c57368700fe1b',
      game_name: 'RAJDHANI DAY',
      open_time: '2023-08-09T09:55:00.000Z',
      close_time: '2023-08-09T11:55:00.000Z',
      createdAt: '2023-07-30T10:24:32.261Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c63a923ddaf00033834fd5',
      user: '64c540710f7c57368700fe1b',
      game_name: 'SUPREME DAY',
      open_time: '2023-08-09T09:55:00.000Z',
      close_time: '2023-08-09T11:55:00.000Z',
      createdAt: '2023-07-30T10:25:22.082Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c63ab83ddaf0003383500f',
      user: '64c540710f7c57368700fe1b',
      game_name: 'KALYAN ',
      open_time: '2023-08-09T10:30:00.000Z',
      close_time: '2023-08-09T12:30:00.000Z',
      createdAt: '2023-07-30T10:26:00.715Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c63b2a3ddaf00033835114',
      user: '64c540710f7c57368700fe1b',
      game_name: 'SRIDEVI NIGHT ',
      open_time: '2023-08-09T13:25:00.000Z',
      close_time: '2023-08-09T14:25:00.000Z',
      createdAt: '2023-07-30T10:27:54.789Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c63b5c3ddaf0003383517c',
      user: '64c540710f7c57368700fe1b',
      game_name: 'RUDRAKSHA NIGHT ',
      open_time: '2023-08-09T14:30:00.000Z',
      close_time: '2023-08-09T16:30:00.000Z',
      createdAt: '2023-07-30T10:28:44.398Z',
      updatedAt: '2023-08-09T07:14:30.529Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c69dbd1f058d00324dc0e2',
      user: '64c540710f7c57368700fe1b',
      game_name: 'MADHUR NIGHT ',
      open_time: '2023-08-09T14:55:00.000Z',
      close_time: '2023-08-09T16:55:00.000Z',
      createdAt: '2023-07-30T17:28:29.993Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c69de51f058d00324dc13a',
      user: '64c540710f7c57368700fe1b',
      game_name: 'SUPREME NIGHT ',
      open_time: '2023-08-09T15:05:00.000Z',
      close_time: '2023-08-09T17:05:00.000Z',
      createdAt: '2023-07-30T17:29:09.794Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c69e0b1f058d00324dc190',
      user: '64c540710f7c57368700fe1b',
      game_name: 'MILAN NIGHT ',
      open_time: '2023-08-09T15:25:00.000Z',
      close_time: '2023-08-09T17:25:00.000Z',
      createdAt: '2023-07-30T17:29:47.645Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c69e321f058d00324dc1e8',
      user: '64c540710f7c57368700fe1b',
      game_name: 'KALYAN NIGHT ',
      open_time: '2023-08-09T15:40:00.000Z',
      close_time: '2023-08-09T17:50:00.000Z',
      createdAt: '2023-07-30T17:30:26.579Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c69e5a1f058d00324dc23f',
      user: '64c540710f7c57368700fe1b',
      game_name: 'RAJDHANI NIGHT ',
      open_time: '2023-08-09T15:50:00.000Z',
      close_time: '2023-08-09T18:05:00.000Z',
      createdAt: '2023-07-30T17:31:06.530Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
    {
      market_status: 'running',
      stop_open_bid: false,
      stop_close_bid: false,
      open_pana: '',
      open_digit: '',
      close_digit: '',
      close_pana: '',
      is_active: true,
      reset_game_date: '2023-08-09T02:00:00.000Z',
      _id: '64c69e901f058d00324dc2b2',
      user: '64c540710f7c57368700fe1b',
      game_name: 'MAIN BAZAR ',
      open_time: '2023-08-09T15:55:00.000Z',
      close_time: '2023-08-09T18:25:00.000Z',
      createdAt: '2023-07-30T17:32:00.900Z',
      updatedAt: '2023-08-09T07:01:52.438Z',
      __v: 0,
    },
  ],
};
